module.exports = __webpack_public_path__ + "img/half-circle-lightgray.870f89f8.svg";